// this file was prevaled
module.exports={"name":"soapbox-fe","displayName":"Coffee","url":"https://github.com/mastodon/mastodon","repository":"mastodon/mastodon","version":"3.0.0-3b05300","homepage":"https://mastodon.coffee/"};